/* eslint-disable max-len */
export const survey = {
  questionnaire: 'Анкета',
  survey: 'Сурамжылоо',
  question: 'Суроо',
  'survey-finished': 'Анкета аяктады. Рахмат!',
  'answers-successfuly-sent': 'Анкета аяктады. Рахмат!',
  'to-next-stage': 'Кийинки баскычка өтүү',
  'nth-question-from-x': '{total} суроонун {current}-суроосу',
  'response-time': 'Жооп берүүгө убакыт',
  'finish-questionnaire': 'Анкетаны аяктоо',
  'next-question': 'Кийинки суроо',
  'video-interview': 'Видеоинтервью',
  'selection-stages': 'Тандоо баскычтары',
  'start-interview-notice': 'Видеоинтервьюдан өтүү үчүн суроолорго жоопторду жаздыруу зарыл. Суроолор текст же видео форматында берилиши мүмкүн. Жаздыруу үчүн сизге камерасы жана микрофону бар компьютер, смартфон же планшет керек болот.',
};
